import { Slider } from '../controls/Slider';
import { useActive } from './useActive';
import { useT, type MessageKey } from '../../i18n';
import { useLibrary } from '../../state/library';
import { runMatchExposure } from '../../features/actions';

const KEYS: { key: 'contrast' | 'highlights' | 'shadows' | 'whites' | 'blacks'; label: MessageKey }[] = [
  { key: 'contrast', label: 'contrast' },
  { key: 'highlights', label: 'highlights' },
  { key: 'shadows', label: 'shadows' },
  { key: 'whites', label: 'whites' },
  { key: 'blacks', label: 'blacks' },
];

export function LightPanel() {
  const { settings, update } = useActive();
  const t = useT();
  const many = useLibrary((s) => s.selected.size > 1);
  return (
    <div>
      {many && (
        <button
          style={{ marginBottom: 6 }}
          title={t('matchExposureHint')}
          onClick={() => void runMatchExposure()}
          data-testid="match-exposure"
        >
          {t('matchExposure')}
        </button>
      )}
      <Slider
        label="exposure"
        testId="slider-exposure"
        value={settings.light.exposure}
        min={-5}
        max={5}
        step={0.01}
        digits={2}
        onChange={(v, final) => update((s) => void (s.light.exposure = v), final)}
      />
      {KEYS.map(({ key, label }) => (
        <Slider
          key={key}
          label={label}
          testId={`slider-${key}`}
          value={settings.light[key]}
          min={-100}
          max={100}
          step={1}
          onChange={(v, final) => update((s) => void (s.light[key] = v), final)}
        />
      ))}
    </div>
  );
}
